import React from 'react'
import {connectCurrentRefinements} from 'react-instantsearch-dom'

const ClearRefinements = ({items, refine}) => (
    <div className="padding-top-1x"
        onClick={() => {
            //Dont reset Collections attribute
            const newItems = items
            const index = newItems.findIndex(x => x.attribute === `collections`)
            if (index > -1) {
                newItems.splice(index, 1)
            }
            refine(newItems)
        }}>
        <a className="">
            Clear All
        </a>
    </div>
)

const ClearFilters = connectCurrentRefinements(ClearRefinements)

export default ClearFilters
